module.exports = __webpack_public_path__ + "img/ic-sort-up.ff349e6a.svg";